import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import EventTabs from './eventComponent/EventTabs/EventTabs';
import ServiceButtons from '../redesign/components/ServiceButtons';
import { setShowEventTabs } from '../store/serviceBookingSlice';
import ServiceBookingDialog from '../redesign/components/quickservices/ServiceBookingDialog';
import ProviderSelectionDialog from '../redesign/components/quickservices/ProviderSelectionDialog';
import './EventTabsWithServiceButtons.css';

const EventTabsWithServiceButtons = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  
  // Get ALL relevant state from serviceBooking slice
  const {
    showEventTabs,
    serviceType,
    commonData,
    selectedProviders
  } = useSelector(state => state.serviceBooking);
console.log("testing",  commonData,)


  // Check if we should show EventTabs
  useEffect(() => {
    // Check for pending service data in localStorage
    // const pendingServiceData = localStorage.getItem('pendingServiceData');
    const pendingCartData = localStorage.getItem('pendingCartData');
    const showEventTabsAfterLogin = localStorage.getItem('showEventTabsAfterLogin');


    // // Rule 1: If there's pending service data (user was in middle of booking)
    // if (pendingServiceData) {
     
    //   dispatch(setShowEventTabs(false));
    //   return;
    // }

    // Rule 2: If there's pending cart data (cart needs processing)
    if (pendingCartData) {
     
      dispatch(setShowEventTabs(true));
      localStorage.removeItem('pendingCartData');
      return;
    }

    // Rule 3: If flag is set to show EventTabs after login
    if (showEventTabsAfterLogin === 'true') {
     
      dispatch(setShowEventTabs(true));
      localStorage.removeItem('showEventTabsAfterLogin');
      return;
    }

    // Rule 4: If user has an active serviceType in Redux (already started booking)
    // Commented out to prevent forcing dashboard navigation on clicking service buttons
    // if (serviceType && serviceType !== '') {
    //   dispatch(setShowEventTabs(true));
    //   return;
    // }

    // Rule 5: If user has commonData (address, event date, etc.)
    const hasBasicCommonData = commonData.address && commonData.eventDate;
    console.log("checking",hasBasicCommonData,serviceType,selectedProviders)
    if (hasBasicCommonData) {
     
      dispatch(setShowEventTabs(true));
      return;
    }

    // Rule 6: If user has items in cart
    if (selectedProviders.length > 0) {
      
      dispatch(setShowEventTabs(true));
      return;
    }

    // Rule 7: Default - if user is logged in, show EventTabs
    // if (isLoggedIn) {
     
    //   dispatch(setShowEventTabs(true));
    //   return;
    // }

    // Rule 8: Default for non-logged in users - show ServiceButtons
   
    dispatch(setShowEventTabs(false));

  }, [isLoggedIn, dispatch, serviceType, commonData, selectedProviders]);

  const handleShowEvents = () => {
    
    dispatch(setShowEventTabs(true));
  };
  
  const handleBackToServices = () => {
    
    dispatch(setShowEventTabs(false));
  };
  
  // Determine what to show based on showEventTabs state
  return (
    <div className="event-tabs-wrapper">
      {showEventTabs && (
        <button 
          className="back-to-services-btn"
          onClick={handleBackToServices}
        >
          <i className='pi pi-arrow-left'></i> Back to Dashboard
        </button>
      )}
           {(isLoggedIn && !showEventTabs)&& (
            <div className="show-events-button-container">
              <button 
                className="show-events-btn"
                onClick={handleShowEvents}
              >
                My Events <i className='pi pi-arrow-right'></i>
              </button>
            </div>
          )}
      {!showEventTabs ? (
        <div className="service-buttons-section">
          <ServiceButtons 
            isLoggedIn={isLoggedIn}
          />
     
        </div>
      ) : (
        <EventTabs />
      )}
      <ServiceBookingDialog />
      <ProviderSelectionDialog />
    </div>
  );
};

export default EventTabsWithServiceButtons;